import {  Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PartnerdatamanagementService {
  public selectedPartner =  new Subject<Object>();
  // private selectedPartner = new BehaviorSubject({});
  // currentPartner = this.selectedPartner.asObservable();
  constructor() { }
  changePartner(message: string) {
    this.selectedPartner.next(message)
  }
 
}
